/* v8 ignore start */
import React from 'react';
import PropTypes from 'prop-types';
import Styles from './themes/WidgetSettingLight.css';
import WidgetSettingRow from './WidgetSettingRow';
import themeable from 'zignal-landscape/lib/themeable';

const WidgetSettings = (props) => {
  const {
    profileOptions,
    smartFilters,
    setSetting,
    setSelectedCols,
    wizardStore,
    timezone
  } =props;
  const { widgetSettings } = wizardStore;
  return (
    <div className={Styles.container}>
      Select which settings you want to change and apply your changes. By Selecting a setting
      and leaving it blank, it will clear any previous settings applied.
      { Object.keys(widgetSettings||{})
        .filter((key) => widgetSettings[key].visible)
        .map((key) => {
          const rowProps = {key, ...widgetSettings[key]};
          return (
            <WidgetSettingRow
              key={key}
              rowProps={rowProps}
              smartFilters={smartFilters}
              profileOptions={profileOptions}
              setSetting={setSetting}
              timezone={timezone || wizardStore.timezone}
              setSelectedCols={setSelectedCols}
              datePickerMinDate={wizardStore.datePickerMinDate}
            />
          );
        })}
    </div>
  );
};

WidgetSettings.propTypes = {
  profileOptions: PropTypes.array,
  smartFilters: PropTypes.array,
  setSetting: PropTypes.func,
  setSelectedCols: PropTypes.func,
  wizardStore: PropTypes.object,
  timezone: PropTypes.string
};

export default themeable(WidgetSettings);
